import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
const NAV = [{
  label: 'About',
  href: '#about'
}, {
  label: 'Vision',
  href: '#vision'
}, {
  label: 'Product',
  href: '#product'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'border-b border-black/[0.06] bg-white/85 backdrop-blur-xl' : 'border-b border-transparent bg-transparent'}`} data-id="element-31" data-mp="vre9knl9j7v0">
      <nav className="flex h-[72px] w-full items-center justify-between px-4 sm:px-6 md:h-20 md:px-8" data-id="element-32" data-mp="38qv3r0rur2w">
        <a href="#top" className="shrink-0" aria-label="Haerumbah home" data-id="element-33" data-mp="3ug3bw4xqt2ia">
          <Logo markClassName="h-10 w-10" wordClassName="text-[22px]" data-id="element-34" data-mp="6unctsm10gn5" />
        </a>

        <ul className="hidden items-center gap-9 md:flex" data-id="element-35" data-mp="bu8e49oo5131">
          {NAV.map(item => <li key={item.href} data-id="element-36" data-mp="glhwcp7w124w">
              <a href={item.href} className="group relative text-[15px] font-medium text-ink/70 transition-colors hover:text-ink" data-id="element-37" data-mp="gmjax3o446rd">
                {item.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-vermillion transition-all duration-300 group-hover:w-full" data-id="element-38" data-mp="3k26w9scytdll" />
              </a>
            </li>)}
          <li data-id="element-39" data-mp="3p1thanz1by4y">
            <a href="#contact" className="rounded-full bg-ink px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-black" data-id="element-40" data-mp="3p3e5lvurakud">
              Get in touch
            </a>
          </li>
        </ul>

        <button className="md:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-41" data-mp="1u93m78ov0nj">
          {open ? <XIcon className="h-6 w-6" data-id="element-42" data-mp="1dapmybnd61fo" /> : <MenuIcon className="h-6 w-6" data-id="element-43" data-mp="1d9xrr1xoi5px" />}
        </button>
      </nav>

      {open && <div className="border-t border-black/[0.06] bg-white/95 backdrop-blur-xl md:hidden" data-id="element-44" data-mp="3ab29jiugj28a">
          <ul className="mx-auto flex max-w-6xl flex-col px-6 py-4" data-id="element-45" data-mp="35cikh9kkhabp">
            {NAV.map(item => <li key={item.href} data-id="element-46" data-mp="3jc0bzwp8z1or">
                <a href={item.href} onClick={() => setOpen(false)} className="block py-3 text-base font-medium text-ink/80" data-id="element-47" data-mp="3jca1lj6dr6tx">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </div>}
    </header>;
}